module.exports = __webpack_public_path__ + "img/intelligent1.b7afedd7.png";